<div class="d-flex li" [ngClass]="{'active': isInDetail == true}">
    <div class="r"></div>
    <div class="p-2 check">
        <mat-checkbox></mat-checkbox>
    </div>
    <div class="p-2 name"
        [routerLink]="['./', id]"
        routerLinkActive="active">Title</div>
    <div class="p-2 status">Status</div>
    <div class="p-2 user">user</div>
    <div class="p-2 users">users</div>
    <div class="p-2 date">issue date</div>
</div>